export default __webpack_public_path__ + "static/media/pic8.cfa34ad2.jpg";